import { render } from "./PromptImportErrorDialog.vue?vue&type=template&id=6254511a&scoped=true&ts=true"
import script from "./PromptImportErrorDialog.vue?vue&type=script&lang=ts"
export * from "./PromptImportErrorDialog.vue?vue&type=script&lang=ts"

import "./PromptImportErrorDialog.vue?vue&type=style&index=0&id=6254511a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6254511a"]])

export default __exports__